import type {BuildId, NormalizedBuild} from '../../../../types'
import {stringifyId} from '../../../../types'
import {getBuildOvertimeInfo} from '../../../../utils/buildOvertime'

export const getSnapshotDependenciesLocator = (buildId: BuildId | null | undefined) =>
  `defaultFilter:false,snapshotDependency(to:(id:${stringifyId(buildId)})),count:-1`

export const getSnapshotDependenciesCounters = (builds: ReadonlyArray<NormalizedBuild>) => {
  let finishedFailed = 0
  let finishedSuccessful = 0
  let queued = 0
  let canceled = 0
  let failedToStart = 0
  let runningFailed = 0
  let runningSuccessful = 0
  let overdue = 0

  builds.forEach(build => {
    if (build.status === 'SUCCESS') {
      if (build.state === 'running') {
        runningSuccessful += 1
      } else {
        finishedSuccessful += 1
      }
    }

    if (build.status === 'FAILURE') {
      if (build.failedToStart) {
        failedToStart += 1
      } else if (build.state === 'running') {
        runningFailed += 1
      } else {
        finishedFailed += 1
      }
    }

    if (build.status === 'UNKNOWN') {
      canceled += 1
    }

    if (build.state === 'queued') {
      queued += 1
    }

    if (getBuildOvertimeInfo(build).isOvertime) {
      overdue += 1
    }
  })

  return {
    finishedFailed,
    finishedSuccessful,
    queued,
    canceled,
    failedToStart,
    runningFailed,
    runningSuccessful,
    overdue,
  }
}
